import { render } from "./VehiculoList.vue?vue&type=template&id=5920677a&scoped=true"
import script from "./VehiculoList.vue?vue&type=script&lang=js"
export * from "./VehiculoList.vue?vue&type=script&lang=js"

import "./VehiculoList.vue?vue&type=style&index=0&id=5920677a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5920677a"]])

export default __exports__